import * as fetch from './fetch'

export function addComment(newComment, token) {
  const endpoint = `/comments/`;
  return fetch.POST(endpoint, token, newComment, true);
}

export function getCommentsForCompany(companyId, token) {
  const endpoint = '/comments/byCompany/' + companyId;
  return fetch.GET(endpoint, token, true)
}

export function getCommentsForTempCompany(tempCompanyId, token) {
  const endpoint = '/comments/byTempCompany/' + tempCompanyId;
  return fetch.GET(endpoint, token, true)
}

export function updateComment(commentId, updatedComment, token) {
  const endpoint = `/comments/${commentId}`;
  return fetch.PUT(endpoint, token, updatedComment, true);
}

export function deleteComment(commentId, token) {
  const endpoint = `/comments/${commentId}`;
  return fetch.DELETE(endpoint, token, true);
}
